import { MutableRefObject } from 'react';
import { useUnit } from 'effector-react';
import { Badge, IconButton } from '@mui/material';
import PhoneIcon from '@mui/icons-material/PhoneOutlined';
import { $contactCalls } from '../../model/calls';
import { $isPopperVisible, setPopperVisiblity } from '../../model/main';

export const ContactCallsBadge = ({
  badgeRef,
}: {
  badgeRef: MutableRefObject<HTMLButtonElement | null>;
}) => {
  const [isPopperVisible] = useUnit([$isPopperVisible]);
  const [contactCalls] = useUnit([$contactCalls]);

  const changeVisibility = () => {
    if (isPopperVisible) {
      setPopperVisiblity(false);
      return;
    }

    setPopperVisiblity('all');
  };

  const invisible = !contactCalls.filter(({ call }) => !call.started_at && !call.ended_at)
    .length;

  return (
    <IconButton size="medium" onClick={changeVisibility} ref={badgeRef}>
      <Badge variant="dot" color="warning" invisible={invisible}>
        <PhoneIcon />
      </Badge>
    </IconButton>
  );
};
